import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { useAppSelector } from '../store';
import { AppSettings } from '../Configuration/types';
import { getMsalInstance } from './msalInstance';
import { PropsWithChildren } from 'react';
import CompanyProgressBar from '../Components/Loading/CompanyProgressBar';

/**
 * Authentication component rendering the MSAL Provider and Authentication Template to authenticate the user.
 */
export default function AuthenticationProvider(props: PropsWithChildren) {
  const { scope } = useAppSelector((state) => (state.appSettings as AppSettings).azure);

  return (
    <MsalProvider instance={getMsalInstance()}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={{
          scopes: [scope]
        }}
        loadingComponent={CompanyProgressBar}>
        {props.children}
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
}
